namespace TabAurous.Stock {
    export interface StockReportRow {
        StockId?: number;
        TransId?: number;
        TransItemId?: number;
        RefTransId?: number;
        RefTransItemId?: number;
        VoucherDate?: string;
        VoucherTypeId?: number;
        VoucherNo?: string;
        RefVoucherId?: number;
        DepartmentId?: number;
        PartyId?: number;
        Line_No?: number;
        BagNo?: string;
        SKU?: string;
        LotNo?: string;
        CertificateNo?: string;
        Lab?: string;
        RefNo?: string;
        GroupId?: string;
        ItemTypeId?: number;
        HSN?: string;
        ProductId?: number;
        ProductCode?: string;
        AttributeId?: number;
        ProductTypeId?: number;
        CategoryId?: number;
        CategoryName?: string;
        ProductTypeName?: string;
        StoneStatusId?: number;
        Studded?: number;
        Pieces?: number;
        Weight?: number;
        NetWeight?: number;
        DiamondPieces?: number;
        DiamondWeight?: number;
        StonePieces?: number;
        StoneWeight?: number;
        OtherPieces?: number;
        Rate?: number;
        OtherWeight?: number;
        MetalAmount?: number;
        DiamondAmount?: number;
        StoneAmount?: number;
        OtherAmount?: number;
        CalcOnId?: number;
        ImageName?: string;
        CompanyId?: number;
        FinancialYearId?: number;
        POSCustomerId?: number;
        Purity?: number;
        PureWeight?: number;
        SetId?: number;
        TotalPieces?: number;
        Pieces0?: number;
        Pieces30?: number;
        Pieces60?: number;
        Pieces90?: number;
        Pieces120?: number;
        Pieces150?: number;
        Pieces180?: number;
        PurchaseTotal?: number;
        SalesTotal?: number;
        Profit?: number;
        ProfitPercent?: number;
    }

    export namespace StockReportRow {
        export const idProperty = 'StockId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Stock.StockReport';
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            StockId = "StockId",
            TransId = "TransId",
            TransItemId = "TransItemId",
            RefTransId = "RefTransId",
            RefTransItemId = "RefTransItemId",
            VoucherDate = "VoucherDate",
            VoucherTypeId = "VoucherTypeId",
            VoucherNo = "VoucherNo",
            RefVoucherId = "RefVoucherId",
            DepartmentId = "DepartmentId",
            PartyId = "PartyId",
            Line_No = "Line_No",
            BagNo = "BagNo",
            SKU = "SKU",
            LotNo = "LotNo",
            CertificateNo = "CertificateNo",
            Lab = "Lab",
            RefNo = "RefNo",
            GroupId = "GroupId",
            ItemTypeId = "ItemTypeId",
            HSN = "HSN",
            ProductId = "ProductId",
            ProductCode = "ProductCode",
            AttributeId = "AttributeId",
            ProductTypeId = "ProductTypeId",
            CategoryId = "CategoryId",
            CategoryName = "CategoryName",
            ProductTypeName = "ProductTypeName",
            StoneStatusId = "StoneStatusId",
            Studded = "Studded",
            Pieces = "Pieces",
            Weight = "Weight",
            NetWeight = "NetWeight",
            DiamondPieces = "DiamondPieces",
            DiamondWeight = "DiamondWeight",
            StonePieces = "StonePieces",
            StoneWeight = "StoneWeight",
            OtherPieces = "OtherPieces",
            Rate = "Rate",
            OtherWeight = "OtherWeight",
            MetalAmount = "MetalAmount",
            DiamondAmount = "DiamondAmount",
            StoneAmount = "StoneAmount",
            OtherAmount = "OtherAmount",
            CalcOnId = "CalcOnId",
            ImageName = "ImageName",
            CompanyId = "CompanyId",
            FinancialYearId = "FinancialYearId",
            POSCustomerId = "POSCustomerId",
            Purity = "Purity",
            PureWeight = "PureWeight",
            SetId = "SetId",
            TotalPieces = "TotalPieces",
            Pieces0 = "Pieces0",
            Pieces30 = "Pieces30",
            Pieces60 = "Pieces60",
            Pieces90 = "Pieces90",
            Pieces120 = "Pieces120",
            Pieces150 = "Pieces150",
            Pieces180 = "Pieces180",
            PurchaseTotal = "PurchaseTotal",
            SalesTotal = "SalesTotal",
            Profit = "Profit",
            ProfitPercent = "ProfitPercent"
        }
    }
}
